var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYellowBoat = function SvgYellowBoat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 108,
    viewBox: "0 0 165 108",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9595 71.3513L0 50.2507L55.682 48.4924L43.9595 71.3513Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9595 71.3513L0 50.2507L55.682 48.4924L43.9595 71.3513Z",
    fill: "url(#yellow_boat_paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.017 70.7653L107.261 47.9064L164.115 45.5619L126.017 70.7653Z",
    fill: "#C4C4C4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.017 70.7653L107.261 47.9064L164.115 45.5619L126.017 70.7653Z",
    fill: "url(#yellow_boat_paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9781 90.4634L82.2054 0.782089L133.029 73.3684L92.0009 96.4584L81.9781 90.4634Z",
    fill: "url(#yellow_boat_paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2359 0L23.0534 68.7246L82.2359 88.9509V0Z",
    fill: "url(#yellow_boat_paint3_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.472 0.570328L22.2895 69.2949L81.472 89.5213V0.570328Z",
    fill: "url(#yellow_boat_paint4_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3557 98.7129L0.781494 51.188L77.5549 62.1836L164.897 46.4989L147.518 94.3789L80.6506 108L19.3557 98.7129Z",
    fill: "url(#yellow_boat_paint5_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5742 97.9307L0 50.4058L76.7734 61.4014L164.115 45.7167L146.736 93.5967L79.8691 107.218L18.5742 97.9307Z",
    fill: "url(#yellow_boat_paint6_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5742 97.9307L0 50.4058L76.7734 61.4014L164.115 45.7167L146.736 93.5967L79.8691 107.218L18.5742 97.9307Z",
    fill: "url(#yellow_boat_paint7_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow_boat_paint0_linear",
    x1: 27.841,
    y1: 48.4924,
    x2: 27.841,
    y2: 71.3513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow_boat_paint1_linear",
    x1: 135.688,
    y1: 45.5619,
    x2: 135.688,
    y2: 70.7653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow_boat_paint2_linear",
    x1: 137.749,
    y1: -56.1305,
    x2: 97.1508,
    y2: 175.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FDC73C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow_boat_paint3_linear",
    x1: 69.7468,
    y1: -25.7888,
    x2: 70.919,
    y2: 161.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow_boat_paint4_linear",
    x1: 81.6648,
    y1: 52.5548,
    x2: 5.27514,
    y2: -26.3747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow_boat_paint5_linear",
    x1: 82.8369,
    y1: 25.5539,
    x2: 1.00551,
    y2: 213.838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC73C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF425C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow_boat_paint6_linear",
    x1: 80.8831,
    y1: 75.8037,
    x2: 82.0554,
    y2: 150.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC73C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellow_boat_paint7_linear",
    x1: -100.615,
    y1: 70.138,
    x2: 232.295,
    y2: 69.7472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856273,
    stopColor: "#FDC73C"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowBoat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellow_boat.6fc0ac0f.svg";
export { ForwardRef as ReactComponent };